<template>
  <nav 
    class="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
    :class="[
      isScrolled 
        ? 'bg-white/95 backdrop-blur-md shadow-lg shadow-gray-900/5 border-b border-gray-100' 
        : 'bg-transparent border-b border-transparent'
    ]">
    <div class="container mx-auto px-4 py-4 flex items-center justify-between">
      <!-- Logo -->
      <div class="flex items-center">
        <a href="/" class="flex items-center gap-2 group">
          <div class="w-9 h-9 rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center shadow-lg shadow-primary-500/30 group-hover:shadow-xl group-hover:shadow-primary-500/40 group-hover:scale-110 transition-all duration-300">
            <i class="i-material-symbols-smart-toy text-white text-xl"></i>
          </div>
          <span class="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary-600 to-primary-500 group-hover:from-primary-500 group-hover:to-purple-500 transition-all duration-300">Lagent</span>
        </a>
      </div>
      <!-- 移动端菜单按钮 -->
      <button @click="isMenuOpen = !isMenuOpen" class="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors">
        <svg class="w-6 h-6 transition-transform duration-300" :class="{ 'rotate-90': isMenuOpen }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path v-if="!isMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
      <!-- 桌面端菜单 -->
      <div class="hidden md:flex items-center space-x-8">
        <a href="#features" class="nav-link text-gray-600 hover:text-primary-600 transition-all duration-300 font-medium relative group">
          {{ t('web.header.features') }}
          <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary-500 group-hover:w-full transition-all duration-300"></span>
        </a>
        <a href="#" class="nav-link text-gray-600 hover:text-primary-600 transition-all duration-300 font-medium relative group">
          {{ t('web.header.tiktok') }}
          <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary-500 group-hover:w-full transition-all duration-300"></span>
        </a>
        <Link href="/pricing" class="nav-link text-gray-600 hover:text-primary-600 transition-all duration-300 font-medium relative group">
          {{ t('web.header.pricing') }}
          <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary-500 group-hover:w-full transition-all duration-300"></span>
        </Link>
      </div>
      <button class="hidden md:flex items-center gap-2 bg-primary-500 text-white px-6 py-2.5 rounded-full hover:bg-primary-600 transition-all duration-300 font-semibold shadow-lg shadow-primary-500/25 hover:shadow-xl hover:shadow-primary-500/30 hover:-translate-y-0.5 group">
        <span>{{ t('web.home.getStarted') }}</span>
        <i class="i-material-symbols-arrow-forward text-lg group-hover:translate-x-1 transition-transform duration-300"></i>
      </button>
    </div>
    <!-- 移动端菜单 -->
    <Transition
      enter-active-class="transition-all duration-300 ease-out"
      enter-from-class="opacity-0 -translate-y-4"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition-all duration-200 ease-in"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-4"
    >
      <div v-if="isMenuOpen" class="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-100 shadow-lg">
        <div class="container mx-auto px-4 py-6 space-y-4">
          <a href="#features" @click="isMenuOpen = false" class="flex items-center gap-3 text-gray-600 hover:text-primary-600 transition-colors font-medium py-2">
            <i class="i-material-symbols-star text-primary-500"></i>
            {{ t('web.header.features') }}
          </a>
          <a href="#" class="flex items-center gap-3 text-gray-600 hover:text-primary-600 transition-colors font-medium py-2">
            <i class="i-material-symbols-play-circle text-primary-500"></i>
            {{ t('web.header.tiktok') }}
          </a>
          <Link href="/pricing" class="flex items-center gap-3 text-gray-600 hover:text-primary-600 transition-colors font-medium py-2">
            <i class="i-material-symbols-payments text-primary-500"></i>
            {{ t('web.header.pricing') }}
          </Link>
          <button class="w-full flex items-center justify-center gap-2 bg-primary-500 text-white px-6 py-3 rounded-xl hover:bg-primary-600 transition-all duration-300 font-semibold shadow-lg shadow-primary-500/25 mt-4">
            <span>{{ t('web.home.getStarted') }}</span>
            <i class="i-material-symbols-arrow-forward"></i>
          </button>
        </div>
      </div>
    </Transition>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { Link } from '@inertiajs/vue3'

const { t } = useI18n()

// 移动端菜单状态
const isMenuOpen = ref(false)

// 滚动状态
const isScrolled = ref(false)

const handleScroll = () => {
  isScrolled.value = window.scrollY > 20
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true })
  handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>
